import { route } from 'frontend/inertia/routes'

export const learningStatisticsPath = {
  // mirrors frontend_academy_partner_learning_statistics
  index: route('/academy_partner/learning_statistics'),
  // mirrors frontend_academy_partner_learning_statistic
  show: route('/academy_partner/learning_statistics/:id'),
}

export const assignedLearningPlanPath = {
  // mirrors frontend_academy_partner_learning_statistic_assigned_learning_plans
  create: route(
    '/academy_partner/learning_statistics/:learning_statistic_id/assigned_learning_plans',
  ),
  // mirrors frontend_academy_partner_learning_statistic_assigned_learning_plan
  show: route(
    '/academy_partner/learning_statistics/:learning_statistic_id/assigned_learning_plans/:learning_plan_id',
  ),
}
